import { render, staticRenderFns } from "./client-space-box.1.vue?vue&type=template&id=0cac5384&scoped=true"
import script from "./client-space-box.1.vue?vue&type=script&lang=js"
export * from "./client-space-box.1.vue?vue&type=script&lang=js"
import style0 from "./client-space-box.1.vue?vue&type=style&index=0&id=0cac5384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac5384",
  null
  
)

export default component.exports